import { Checkbox, TableCell, TableCellProps, TableRow, TableSortLabel } from '@mui/material';
import { StyledTableHead } from 'Components/TableBase/Table';
import React, { ChangeEvent, FC, Fragment } from 'react';

interface ISortableTableHeadProps {
  order?: 'asc' | 'desc';
  orderBy?: string;
  headerColumns: IHeaderColumn[];
  multiselect?: boolean;
  onSort?: (id: string) => void;
  onSelectAll?: (select: boolean) => void;
}

/**
 * @deprecated
 */

export interface IHeaderColumn<Key = string> extends Omit<Partial<TableCellProps>, 'id'> {
  id: Key;
  headerName: string;
  sortable: boolean;
  align?: 'left' | 'right' | 'center';
}

/**
 *  @deprecated Use new designSystem/Table instead
 */
const SortableTableHead: FC<ISortableTableHeadProps> = ({
  order = 'asc',
  orderBy,
  headerColumns,
  multiselect = true,
  onSort,
  onSelectAll,
}) => {
  const handleSelectAll = (event: ChangeEvent<HTMLInputElement>) => {
    onSelectAll?.(event.target.checked);
  };

  return (
    <StyledTableHead>
      <TableRow>
        {onSelectAll ? (
          <TableCell padding="checkbox">
            <Checkbox
              inputProps={{ 'aria-label': 'select all items' }}
              onChange={handleSelectAll}
              disabled={!multiselect}
            />
          </TableCell>
        ) : (
          <Fragment />
        )}
        {headerColumns.map(({ headerName, id, align, sortable, ...headCell }) => (
          <TableCell key={id} align={align === 'right' ? 'right' : 'left'} {...headCell}>
            {sortable ? (
              <TableSortLabel
                active={!!(orderBy && orderBy === id)}
                direction={orderBy && orderBy === id ? order : 'asc'}
                onClick={() => (onSort ? onSort(id) : null)}
              >
                {headerName}
              </TableSortLabel>
            ) : (
              headerName
            )}
          </TableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
};

export default SortableTableHead;
